<div class="form-group" style="margin-top:20px">
  <input type="checkbox" style="transform: scale(2.0);margin-left:10px" [ngModel]="checked" placeholder="{{title}}" (ngModelChange)="change($event)">
  <label class="sa-form-label" style="margin-left:10px">{{title}}</label>
</div>
